import {
  Card,
  CardAnchor,
  CardButton,
  ContextMenuDropdown,
  SkeletonLoader,
  TDropdownItem,
} from '@payaca/ambrosia';
import { Droppable } from '@payaca/dnd';

import UntitledIcon from '@payaca/untitled-icons';
import { FC } from 'react';
import { Link, LinkProps } from 'react-router-dom';

export type TProps = {
  id: string;
  folderName: string;
  to: LinkProps['to'];
  icon?: 'flip-backward.3' | 'folder.3';
  contextMenuItems?: TDropdownItem[];
};

export const FOLDER_CARD_DROP_TYPE = 'folder';

const FolderCard: FC<TProps> = (props) => {
  const { id, folderName, to, icon = 'folder.3', contextMenuItems } = props;

  return (
    <Droppable
      id={`folder-card::${id}`}
      data={{
        type: FOLDER_CARD_DROP_TYPE,
        folderId: id,
      }}
    >
      <CardAnchor
        as={Link}
        title={folderName}
        className="data-[over]:ring-2 data-[over]:ring-blue-500"
        sizeVariant="sm"
        to={to}
      >
        <CardButton.Body className="flex gap-3 items-center">
          <UntitledIcon className="shrink-0 w-4 h-4" name={icon} />

          <p className="truncate">{folderName}</p>

          {contextMenuItems && (
            <ContextMenuDropdown
              className="ml-auto -mr-2 -mt-2 -mb-2"
              size="xs"
              variant="secondary"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
              }}
              menuItems={contextMenuItems}
            />
          )}
        </CardButton.Body>
      </CardAnchor>
    </Droppable>
  );
};

const SkeletonLoaderFolderCard: FC = () => {
  return (
    <Card sizeVariant="sm">
      <Card.Body className="flex gap-3 items-center h-full">
        <UntitledIcon className="shrink-0 w-4 h-4" name="folder.3" />

        <SkeletonLoader.Text />

        {/* Invisible context menu to prevent layout shift */}
        <ContextMenuDropdown
          className="invisible"
          aria-hidden
          size="xs"
          menuItems={[]}
        />
      </Card.Body>
    </Card>
  );
};

export default Object.assign(FolderCard, {
  Loading: SkeletonLoaderFolderCard,
});
